module.exports = __webpack_public_path__ + "img/agility.e2d49eec.png";